module.exports = __webpack_public_path__ + "static/media/UN043497.9a31f1df.jpg";